import {
  Delete,
  ToCRM,
  Watch,
  BlockAuthor,
  ToPodiumTitle,
  ToContacted,
  Exclude,
  Return
} from '../../../composed-components/Actions';
import { IBook } from '../types/types';
import { IRowActionOptions } from './BookstatListTab';

// Row actions of the Daily Digest tabs. Call once at module level per tab to keep the function stable.

// Titles to be acted on: delete, block author, exclude, podium title, watchlist, contacted, CRM (Top Debut, KU Top 100)
export const acquisitionRowActions = (id: string) => (book: IBook, { canSendToCRM }: IRowActionOptions) => (
  <>
    <Delete book={book} id={id} />
    <BlockAuthor book={book} id={id} />
    <Exclude book={book} id={id} />
    <ToPodiumTitle book={book} id={id} />
    <Watch book={book} id={id} />
    <ToContacted book={book} id={id} />
    {canSendToCRM && <ToCRM book={book} id={id} />}
  </>
);

// Excluded titles: delete, block author, watchlist, CRM or return them (Resurfaced Kindle Excluded)
export const excludedRowActions = (id: string) => (book: IBook, { canSendToCRM }: IRowActionOptions) => (
  <>
    <Delete book={book} id={id} />
    <BlockAuthor book={book} id={id} />
    <Watch book={book} id={id} />
    {canSendToCRM && <ToCRM book={book} id={id} />}
    <Return book={book} id={id} />
  </>
);
